/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
// import config from '../../config/createSession.config.json';
import axios from 'axios';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { Graphql } from '@common/graphql';
import { CREATE_SESSION } from '../../api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';

export interface ICreateSessionMethods extends IPluginMethodMap {
  createSession(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class CreateSessionService implements IAgentPlugin {
  readonly methods: ICreateSessionMethods;

  constructor() {
    this.methods = {
      createSession: this.createSession.bind(this),
    };
  }

  async createSession(args: any) {
    console.log(`createSession service:`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const storageService = StorageModule.getInstance();

    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    const payableApplications = storageService.get(
      'payableApplications',
      'session'
    );
    const applications = payableApplications?.map((item: any) => item?.id);
    const status =
      payableApplications?.[0]?.status === 'READY_TO_PAY'
        ? 'APP_PROCESSING_FEE'
        : 'WORK_PERMIT_FEE';
    try {
      if (client) {
        console.log(client);
        const res = await client
          .mutation(CREATE_SESSION, {
            input: {
              cardDetail: args?.cardDetail,
              paymentFor: status,
              // "redirectUri": "https://staging-govj-wp-gw.klefki.io/scooby-rest/fac",
              redirectUri: 'http://localhost:3000/payment-success',
              totalAmount: args?.price * applications?.length,
              applications: applications,
            },
          })
          .toPromise();
        if (res?.data?.createCheckoutSession?.session?.Errors?.length > 0) {
          toast.error(
            res?.data?.createCheckoutSession?.session?.Errors?.[0]?.Message
          );
          throw Error(
            res?.data?.createCheckoutSession?.session?.Errors?.[0]?.Message
          );
        }
        if (res?.data?.createCheckoutSession?.session) {
          return res?.data?.createCheckoutSession?.session;
        }
      }
    } catch (err: any) {
      console.log(`Payment user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
